import React from "react";
import styled, { keyframes } from "styled-components";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import SubVisual from "../Public/SubVisual";
import { Map, MapMarker } from "react-kakao-maps-sdk";
import { DHKS_INFO } from "../../../Models/CompanyInfoData";

const reveal = keyframes`
  from { opacity: 0; transform: translateY(30px); }
  to { opacity: 1; transform: translateY(0); }
`;

const Location = () => {
  return (
    <>
      <Header />
      <SubVisual title="오시는 길" subTitle="회사소개" />

      <PageContainer>
        <InnerWrapper>
          <InfoSection>
            <div className="title-group">
              <h5 className="sub">CONTACT US</h5>
              <h2 className="main">오시는 길</h2>
            </div>
            <div className="address-box">
              <div className="item">
                <span className="label">ADDRESS</span>
                <p>{DHKS_INFO.contact.main.address}</p>
              </div>
              <div className="item-row">
                <div className="sub-item">
                  <span className="label">TEL</span>
                  <p>{DHKS_INFO.contact.main.tel}</p>
                </div>
                <div className="sub-item">
                  <span className="label">FAX</span>
                  <p>{DHKS_INFO.contact.main.fax}</p>
                </div>
              </div>
            </div>
          </InfoSection>

          <MapContainer>
            <div className="map-frame">
              <Map
                id="map"
                center={{
                  lat: 37.4053209,
                  lng: 127.100669,
                }}
                style={{
                  width: "100%",
                  height: "100%", // 이전에 말씀드린 대로 px 단위 권장
                }}
                level={3}
              >
                <MapMarker position={{ lat: 37.4053209, lng: 127.100669 }}>
                  <div
                    style={{
                      color: "#000",
                      textAlign: "center",
                      paddingTop: "2px",
                      paddingLeft: "2px",
                    }}
                  >
                    디에이치케이솔루션
                  </div>
                </MapMarker>
              </Map>
            </div>
            <MapActionButtons>
              <a
                href="https://kko.to/0djQYFowOc"
                target="_blank"
                rel="noreferrer"
              >
                카카오맵으로 길찾기
              </a>
              <a
                href="https://naver.me/Gplc0mU0"
                target="_blank"
                rel="noreferrer"
              >
                네이버 지도로 보기
              </a>
            </MapActionButtons>
          </MapContainer>

          <TransportGrid>
            <TransportCard>
              <div className="type-label">SUBWAY</div>
              <div className="line-deco" />
              <div className="content">
                <p className="main-info">
                  신분당선/경강선{" "}
                  <strong style={{ color: "red" }}>판교역</strong>
                </p>
                <p className="sub-info">
                  4번 출구 하차 후 버스 환승 또는 도보 20분
                </p>
              </div>
            </TransportCard>

            <TransportCard>
              <div className="type-label">BUS</div>
              <div className="line-deco" />
              <div className="content">
                <p className="main-info">
                  판교디지털센터 / 판교이노밸리 정류장
                </p>
                <p className="sub-info">일반: 602-1, 602-2, 71, 73, 75</p>
                <p className="sub-info">마을: 74, 812</p>
              </div>
            </TransportCard>

            <TransportCard>
              <div className="type-label">CAR</div>
              <div className="line-deco" />
              <div className="content">
                <p className="main-info">경부고속도로 판교 IC</p>
                <p className="sub-info">
                  판교 IC 진출 후 판교테크노밸리 방면 2km
                </p>
                <p className="sub-info">
                  내비게이션: '디에이치케이솔루션' 또는 '판교로 255번길 28'
                </p>
              </div>
            </TransportCard>
          </TransportGrid>
        </InnerWrapper>
      </PageContainer>

      <Footer />
    </>
  );
};

export default Location;

const PageContainer = styled.div`
  width: 100%;
  background-color: #fff;
  padding-bottom: 150px;
`;

const InnerWrapper = styled.div`
  width: 90%;
  max-width: 1400px;
  margin: 0 auto;
`;

const InfoSection = styled.div`
  padding: 120px 0 80px 0;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  animation: ${reveal} 1s ease-out forwards;

  .title-group {
    flex: 1;
    .sub {
      font-size: 0.9rem;
      font-weight: 700;
      /* color: #00d2ff; */
      color: gray;
      letter-spacing: 5px;
      margin-bottom: 20px;
    }
    .main {
      font-size: 3.2rem;
      font-weight: 800;
      line-height: 1.3;
      color: #1a1a1a;
      letter-spacing: -1px;
    }
  }

  .address-box {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 40px;
    padding-left: 100px;
    border-left: 1px solid #eee;

    .label {
      display: block;
      font-size: 0.8rem;
      font-weight: 800;
      color: #bbb;
      margin-bottom: 12px;
      letter-spacing: 2px;
    }
    p {
      font-size: 1.15rem;
      color: #1a1a1a;
      line-height: 1.6;
      font-weight: 500;
    }

    .item-row {
      display: flex;
      gap: 60px;
    }
  }

  @media (max-width: 1024px) {
    flex-direction: column;
    .address-box {
      padding-left: 0;
      border-left: none;
      margin-top: 50px;
    }
  }
`;

const MapContainer = styled.div`
  width: 100%;
  margin-bottom: 100px;
  animation: ${reveal} 1s ease-out 0.3s forwards;
  opacity: 0;

  .map-frame {
    width: 100%;
    height: 550px;
    background-color: #f5f5f5;
    border-radius: 4px;
    overflow: hidden;
    box-shadow: 0 30px 60px rgba(0, 0, 0, 0.08);
  }
`;

const MapActionButtons = styled.div`
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-top: 30px;

  a {
    padding: 14px 28px;
    border: 1px solid #eee;
    border-radius: 30px;
    font-size: 0.9rem;
    font-weight: 600;
    color: #666;
    text-decoration: none;
    transition: all 0.3s ease;
    background: #fff;

    &:hover {
      background: #1a1a1a;
      color: #fff;
      border-color: #1a1a1a;
      transform: translateY(-3px);
    }
  }
`;

const TransportGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
  animation: ${reveal} 1s ease-out 0.6s forwards;
  opacity: 0;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
`;

const TransportCard = styled.div`
  padding: 40px 0;
  border-top: 1px solid #eee;

  .type-label {
    font-size: 1rem;
    font-weight: 800;
    color: #1a1a1a;
    letter-spacing: 3px;
    margin-bottom: 20px;
  }

  .line-deco {
    width: 30px;
    height: 3px;
    background-color: #00d2ff;
    margin-bottom: 30px;
  }

  .main-info {
    font-size: 1.25rem;
    font-weight: 700;
    color: #1a1a1a;
    margin-bottom: 15px;
    word-break: keep-all;

    strong {
      color: #00d2ff;
    }
  }

  .sub-info {
    font-size: 1rem;
    color: #777;
    line-height: 1.8;
    margin-bottom: 5px;
  }
`;
